<template>
	<div>
		<div class="w-tabs">
			<div class="tabs">
				<div>
					排期状态: 
					<span>
						{{ 
							{1:'待排期',
							2:'已排期',
							3:'勿访',
							5:'排期过期-待排期',
							6:'排期过期-已排期',
							7:'排期过期-勿访'
							}[schedulingState]
						}}
					</span>
				</div>
				<div style="display: flex;margin-left:16px">
					<div class="tab active" v-if="schedulingState!==3" @click="showDlg(1)">新建排期</div>
					<el-popconfirm v-if="schedulingState==1||schedulingState==5" confirmButtonText='确定' title="确定勿访吗？" @confirm="notVisit">
						<div slot="reference" class="tab not-visit">勿访</div>
					</el-popconfirm>
					<el-popconfirm v-if="schedulingState==2||schedulingState==3||schedulingState==7||schedulingState==6" confirmButtonText='确定' title="确定回退到待排期吗？" @confirm="backToWait">
						<div slot="reference" class="tab not-visit">回退</div>
					</el-popconfirm>
				</div>
			</div>
		</div>
		<div class="table-wrap">
			<el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border :data="list.data" v-loading="isLoading" @selection-change="selectionChange">
				
				<el-table-column prop="expectFollowupDate" label="随访日期" width="120"></el-table-column>	
				<el-table-column prop="remark" label="随访建议" show-overflow-tooltip></el-table-column>			
				<el-table-column prop="creator" label="创建人" width="100"></el-table-column>
				<el-table-column label="随访状态" width="120">
					<template slot-scope="scope">
					<span v-if="scope.row.followupState == 1">待随访</span>
					<span v-if="scope.row.followupState == 2">已随访 </span>
					<span v-if="scope.row.followupState == 3">暂存</span>
					<span v-if="scope.row.followupState == 4">终止随访</span>
					</template>
				</el-table-column>	
								
				<el-table-column prop="createTime" label="排期时间" width="180"></el-table-column>
				
				<el-table-column label="操作" width="190">
					<template slot-scope="scope">
						<div class="tab-action">
							<template v-if="scope.row.followupState == 1">
							<el-tooltip content="修改" placement="top" :enterable="false"><i class="icon-edit" @click="showDlg(2, scope.row)"></i></el-tooltip>
							<el-popconfirm confirmButtonText='删除' title="确定删除吗？" @confirm="delItem(scope.row)">
								<el-tooltip content="删除" slot="reference" placement="top" :enterable="false"><i class="el-icon-delete"></i></el-tooltip>
							</el-popconfirm>								
							
							</template>
							<template v-else>							
							<el-tooltip content="查看" placement="top" :enterable="false"><router-link :to="{name: 'Patient/User', query: {patientId: patientId, t:5, date: scope.row.expectFollowupDate, vid: scope.row.id}}"><i class="icon-research"></i></router-link></el-tooltip>
							</template>
						</div>
					</template>
				</el-table-column>
				
			</el-table>	
			<div class="pagination">
				<el-row>
					<el-col :span="12">
						<div class="record">当前是第<span v-text="(filter.pageNumber-1)*filter.pageSize+1"></span>条至第<span v-text="(filter.pageNumber-1)*filter.pageSize+filter.pageSize"></span>数据</div>
						<div class="record">总计<span v-text="list.total"></span>条记录</div>
					</el-col>
					<el-col :span="12" style="text-align: right;">
						<el-pagination :disabled="isLoading" layout="sizes, prev, pager, next" :page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"  prev-text="上一页" next-text="下一页" :current-page="list.current" :page-size="filter.pageSize" :total="list.total" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
					</el-col>
				</el-row>
			</div>
		</div>		
		

		<el-drawer size="660px" :show-close="false" :visible="dlg.active">
			<template slot="title">
				<div class="el-drawer-close" @click="closeDlg"><i class="el-icon el-icon-arrow-left"></i>返回</div>
				{{!schedule.data ? '新建排期' : '修改排期'}}
				<el-button class="el-drawer-save" type="text" :loading="isLoading" @click="saveForm">保存</el-button>
			</template>
						
			<div class="drawer-content form-schedule">
				<template v-if="schedule.data && schedule.data.id > 0">
					<el-form class="ver" ref="form" label-width="80px" :rules="dlg.rules" :model="schedule.data">
						<el-form-item label="随访日期" prop="expectFollowupDate">
							<el-date-picker size="small" style="width:220px" type="date" align="right" :clearable="false" v-model="schedule.data.expectFollowupDate"></el-date-picker>
						</el-form-item>
						<el-form-item label="随访建议" prop="followupAdvice">
							<el-input type="textarea" size="small" rows="5" resize="none" v-model="schedule.data.followupAdvice"></el-input>
						</el-form-item>
						
						<el-form-item label="是否慎访" prop="carefulVisit">
							<el-radio-group v-model="schedule.data.carefulVisit">
								<el-radio :label="1">是</el-radio>
								<el-radio :label="0">否</el-radio>
							</el-radio-group>
						</el-form-item>
						
						<el-form-item type="textarea" label="慎访原因" prop="carefulVisitReason" v-if="schedule.data.carefulVisit">
							<el-input type="textarea" size="small" rows="5" resize="none" v-model="schedule.data.carefulVisitReason"></el-input>
						</el-form-item>																		
					</el-form>
				</template>
				
				<template v-else>
					<el-form label-width="80px">
						<el-form-item label="排期模板">
							<el-select size="small" filterable clearable v-model="schedule.template" placeholder="请选择模板">
								<el-option v-for="item in templateList" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
							<el-button type="primary" size="mini" round plain @click="addScheduleTemplate">生成排期</el-button>
						</el-form-item>
					</el-form>
					
					<el-form ref="form" label-width="80px" :rules="dlg.rules" :model="schedule">
						<!-- {id: 0, date: '', content: '', careful: false, reason: ''} -->

						<div v-for="(item,idx) in schedule.addList" :key="idx">
							
							<el-form-item label="随访日期" :prop="'addList.'+idx+'.expectFollowupDate'" :rules="dlg.rules.expectFollowupDate">
								<el-date-picker size="small" style="width:220px" type="date" align="right" :clearable="false" :picker-options="pickerOptions" v-model="item.expectFollowupDate"></el-date-picker>
								<div class="action">
									<el-button type="primary" size="mini" round v-if="showGetorders&&(hospitalCode=='YS_HM4'||hospitalCode=='GX_TD2')" @click="getDoctorOrders(idx)" style="margin-right:10px;">获取{{{ 1:'门诊',2:'出院' }[filter.datasources]}}医嘱</el-button>
									<el-popconfirm confirmButtonText="删除" title="确定删除吗？" @confirm="delSchedule(idx)">
										<el-button type="text" class="fc red" slot="reference">删除</el-button>
									</el-popconfirm>
								</div>
							</el-form-item>
							
							<el-form-item label="随访建议" :prop="'addList.'+idx+'.followupAdvice'" :rules="dlg.rules.followupAdvice">
								<el-input type="textarea" size="small" rows="5" resize="none" v-model="item.followupAdvice"></el-input>
							</el-form-item>
							
							<el-form-item label="是否慎访" :prop="'addList.'+idx+'.carefulVisit'" :rules="dlg.rules.carefulVisit">
								<el-radio-group v-model="item.carefulVisit">
									<el-radio :label="1">是</el-radio>
									<el-radio :label="0">否</el-radio>
								</el-radio-group>
							</el-form-item>
							
							<el-form-item type="textarea" label="慎访原因" :prop="'addList.'+idx+'.carefulVisitReason'" :rules="dlg.rules.carefulVisitReason" v-if="item.carefulVisit">
								<el-input type="textarea" size="small" rows="5" resize="none" v-model="item.carefulVisitReason"></el-input>
							</el-form-item>
							<el-divider></el-divider>
						</div>
															
					</el-form>
				</template>
			</div>
			<el-button style="margin: 0 20px;" type="primary" size="mini" v-if="!schedule.data" round plain @click="addSchedule">新增单条随访</el-button>
			
		</el-drawer>
		
	</div>
</template>

<script>
import api from '@/service/api.js';
import mixin from '@/views/mixin';
import dayjs from 'dayjs';

export default {
  mixins: [mixin],
  props: {
      dataId:{
		required: true
	}
  },
	data(){
		return {
			noSidebar: true,
			dlg: {
				active: false,
				rules: {
					expectFollowupDate: {required: true, message: '请选择随访日期'},
					followupAdvice: {required: true, message: '请输入内容'},
					carefulVisit: {required: true, message: '请选择'},
					carefulVisitReason: {required: true, message: '请输入内容'}
				}
			},
			list: {
				current: 1,
				total: 0,
				pageSize: 0,
				data: null
			},
			filter: {
				patientId: 0,
				recordId: '',
				datasources: '',
				pageNumber: 1,
				pageSize: 10
			},
			schedule: {
				active: false,
				template: '',
				data: null,
				list: [],
				addList: []
			},
			templateList: [],
			pickerOptions: {
				// 禁用当天之前的日期
				disabledDate: time=>{return time.getTime() < dayjs(dayjs().format('YYYY/MM/DD'));},
				shortcuts:null
			},
			schedulingState:null,//排期状态
			form: {
				detailId: 0,
				datasources: ''
			},
			showGetorders:false,
			hospitalCode:'YS_HM4'
		}
	},
	created() {
		this.init();
		let query = this.$route.query;
	},
	methods: {
		async getDoctorOrders(idx) {
		const item = this.schedule.addList[idx];
		if (!item) return;

		const recordId = this.$route.query.fid || 0;
		const datasources = +this.$route.query.datasources || 0;
		let code = '';
		if (datasources === 1) code = 'OUTPATIENT';
		else if (datasources === 2) code = 'INPATIENT';

		try {
			const res = await api.getMedicalOrders({
			visitId: recordId,
			visitType: code
			});

			if (res.code === 1 && Array.isArray(res.data)) {
			const content = res.data
				.map(o => o.orderContent || '')
				.join('\n\n')
				.replace(/\r\n/g, '\n');

			this.$set(this.schedule.addList, idx, {
				...item,
				followupAdvice: content
			});

			// this.$message.success(`共获取到 ${res.data.length} 条医嘱`);
			} else {
				this.$message.error('查询医嘱失败: ' + (res.msg || '未知错误'));
			}
		} catch (err) {
			console.error(err);
			// this.$message.error('请求接口异常: ' + (err.message || err));
		}
		},
		async init() {
			this.patientId = +this.$route.query.patientId;
			this.filter.patientId = this.patientId;
			this.filter.recordId = this.$route.query.fid || 0;
			this.filter.datasources = +this.$route.query.datasources || 0;
			this.hospitalCode = await api.getHospitalCode();

			await this.loadList();
			// 下拉 排期模板
			api.getScheduleTemplateList().then((res)=>{
				if (res.code == 1000) {
					this.templateList = res.data;
				}
			});
		},
		async loadList() {
			this.isLoading = true;
			let res = await api.getFollowListByRecordId(this.filter);
			if (res.code == 500) {return;}

			this.list.total = +res.total;
			this.list.current = this.filter.pageNumber;
			this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
			if (res.data) {
				res.data.forEach((item)=>{
					item.expectFollowupDate = dayjs(item.expectFollowupDate).format('YYYY-MM-DD');
				})
				this.list.data = res.data;
			}
			this.isLoading = false;
			this.loadMsg();
		},
		async loadMsg(){
			let res = await api.getFollowUp({
						recordId: this.filter.recordId,
						datasources: this.filter.datasources
				});
			if(res.code==1000){
				this.schedulingState=res.data.schedulingState;
				console.log(this.schedulingState,'=================22')
			}
		},
		async showDlg(v, item) {
			let res;
			switch (v) {
				case 1: 
					this.schedule.data = null;
					this.schedule.addList = [];
					break;
				case 2:
					this.isLoading = true;
					res = await api.getFollowByFollowupId({id: item.id});
					this.isLoading = false;
					if (res.code != 1000) {return this.$message.error(res.message);}
					this.schedule.data = res.data;
					break;
			}
			this.dlg.active = true;
		},
		closeDlg() {
			this.dlg.active = false;
		},
		// 显示 排期 面板
		showSchedule() {
			this.dlg.active = false;
			this.dlg.active2 = true;
			this.schedule.data = null;
			this.schedule.addList = [];
			this.addSchedule();
			this.schedule.active = true;
		},
		// 保存 排期
		// saveSchedule() {
		// 	this.isLoading = true;
		// 	setTimeout(()=>{
		// 		this.isLoading = false;	
		// 		this.closeSchedule();
  //       this.$message.success('保存成功');
		// 	}, 1500)
		// },		
		async saveForm() {
			if (this.schedule.data && this.schedule.data.id > 0) {
				// 修改排期
				this.$refs['form'].validate(async (valid)=>{
					if (valid) {
						this.schedule.data.expectFollowupDate = dayjs(this.schedule.data.expectFollowupDate).format('YYYY-MM-DD 00:00:00');
						this.isLoading = true;
						let res = await api.editFollowByFollowupId(this.schedule.data);
						this.isLoading = false;
						if (res.code != 1000) {
							return this.$message.error(res.message);
						}		
						this.closeDlg();
						this.loadList();
						this.$message.success('保存成功');
					}
				})
			} else {
				// 新建排期
				if (this.schedule.addList.length == 0) {
					return this.$message.warning('请先新建排期');
				}
				this.$refs['form'].validate(async (valid)=>{
					if (valid) {
						this.schedule.addList.forEach(item=>{
							item.expectFollowupDate = dayjs(item.expectFollowupDate).format('YYYY-MM-DD 00:00:00');
						})
						this.isLoading = true;
						let res = await api.addFollow(this.schedule.addList);
						this.isLoading = false;
						if (res.code != 1000) {
							return this.$message.error(res.message);
						}
						this.closeDlg();
						this.loadList();
						this.$message.success('保存成功');
					}
				});
			}
		},
		async delItem(item) {
			// 删除
			this.isLoading = true;
			let res = await api.delFollow({id: item.id});
			this.isLoading = false;
			if (res.code != 1000) {
				return this.$message.error(res.message);
			}
			this.loadList();
			this.$message.success('已删除');
		},
		addSchedule() {
			this.showGetorders=true
			let depId = this.$parent.$parent.$parent.$parent.itemDetail.departmentId;
			this.schedule.addList.push({carefulVisit: 0, carefulVisitReason: '', expectFollowupDate: '', followupAdvice: '', hospitalDepartmentId: depId, patientId: this.patientId, recordId: this.filter.recordId, datasources:this.filter.datasources});
		},		
		// // 修改 排期
		// editSchedule() {
		// 	this.schedule.data = {id: 11, date: '10/02/2020', content: 'content1', careful: true, reason: 'reaso'};
		// 	this.schedule.active = true;
		// },
		// 删除 排期
		delSchedule(idx) {
			this.schedule.addList.splice(idx, 1);
		},	
		async addScheduleTemplate() {
			this.showGetorders=false;
			let depId = this.$parent.$parent.$parent.$parent.itemDetail.departmentId;
			
			if (this.isLoading) {return;}
			if (this.schedule.template == 0) {
				return this.$message.warning('请选择排期模板');
			}
			this.isLoading = true;
			let res = await api.getScheduleTemplateInfo({tempId: this.schedule.template});
			this.isLoading = false;
			if (res.code != 1000) {
				return this.$message.error(res.message);
			}
			if (res.data && res.data.length > 0) {
				res.data.forEach(item=>{
					this.schedule.addList.push({carefulVisit: 0, carefulVisitReason: '', expectFollowupDate: item.expectFollowupDate, followupAdvice: item.templateContent, hospitalDepartmentId: depId, patientId: this.patientId, recordId: this.filter.recordId , datasources:this.filter.datasources});		
				})
			}			
		},
		handleSizeChange(v) {
			this.filter.pageSize = v;
			this.filter.pageNumber = 1;
			this.loadList();
		},
		handleCurrentChange(v) {
			this.filter.pageNumber = v;
			this.loadList();
		},
		// 勿访
		async notVisit() {
			let query = this.$route.query;
			let res;
			this.form.detailId = query.id;
			this.form.datasources = query.datasources;
			this.form.schedulingState = this.schedulingState == 1 ? 3 : 7; // 如果是1待排期，就变成3勿访，否则是7过期勿访;
			this.isLoading = true;
			res = await api.updateScheduleState(this.form);
			this.isLoading = false;
			if (res.code != 1000) {
				return this.$message.error(res.message);
			}
			this.$message.success('保存成功');
			this.loadList();
			this.loadMsg();
		},
		// 回退
		async backToWait(){
			let query = this.$route.query;
			let res;
			this.form.detailId = query.id?query.id:this.dataId;
			this.form.datasources = query.datasources;
			this.form.schedulingState =this.schedulingState;
		
			this.isLoading = true;
			res = await api.rollbackScheduleState(this.form);
			this.isLoading = false;
			if (res.code != 1000) {
				return this.$message.error(res.message);
			}
			this.$message.success('保存成功');
			this.loadList();
			this.loadMsg();

		}
	}
}
</script>

<style lang="less">
@import '@/assets/style/var';
.w-tabs {
	>.tabs {
		padding:8px 30px 20px;
		justify-content: normal !important;
		align-items: center;
		.not-visit,
		.not-visit:focus,
		.not-visit:hover
		{
		border-color: #f56c6c;
		color:#f56c6c;
		margin-right: 0;
		}
	}
	
}
.form-schedule {
	.el-form {
		border-bottom: 1px solid #f5f5f5;
		margin-bottom: 20px;
		&:last-child {
			border-bottom: 0;
		}
		.el-date-editor { margin-left: 0;}
		.el-textarea { width: 100%;}
		.el-select {
			.el-input {width: 140px; margin-right: 20px;}
		}
		
	}
}
</style>